import assetProvider from './AssetProvider';

class AssetService {
  async resolveAsset(urn) {
    try {
      const asset = await assetProvider.getAsset(urn);
      return asset;
    } catch (error) {
      throw new Error('Failed to resolve asset', error);
    }
  }

  static build() {
    return new AssetService();
  }
}

export default AssetService;
